/** Versandrouting Stufe 1 (R112–R124): Schattenentscheidungen, Tarife/Regeln (lesend, Regeln Admin), Abholaufträge. */
import type {
  Abholauftrag, AbholungArt, AbholungStatus, SpitzentagVorschlag, Tarifstand, VersandEntscheidungSicht, Versandregeln, VersandroutingSchalter,
} from '@storeos/contracts';
import { api, post } from '../api';
import { put, qs } from './http';

export const versandwahl = (sendungId: string) => api<{ schalter: VersandroutingSchalter; entscheidungen: VersandEntscheidungSicht[] }>(`/sendungen/${sendungId}/versandwahl`);
export const versandTarife = () => api<{ schalter: VersandroutingSchalter; regeln: Versandregeln; tarife: Tarifstand }>('/versandrouting/tarife');
export const versandRegelnAendern = (r: Partial<Versandregeln>) => put<Versandregeln>('/versandrouting/regeln', r);

export interface AbholungenSicht {
  eintraege: Abholauftrag[];
  konten: Array<{ id: string; code: string; name: string; abholung: string }>;
  heute: { tag: string; pakete: number; vorschlag: SpitzentagVorschlag };
}
export const abholungen = (von?: string) => api<AbholungenSicht>(`/versandrouting/abholungen${qs({ von })}`);
export const abholungAnlegen = (a: { konto_id: string; tag: string; fenster_von: string; fenster_bis: string; art: AbholungArt; anzahl_pakete: number; gewicht_g?: number | null; bemerkung?: string | null }) =>
  post<Abholauftrag>('/versandrouting/abholungen', a);
export const abholungStatus = (id: string, s: { status: AbholungStatus; carrier_referenz?: string | null; storno_grund?: string | null; fehler?: string | null }) =>
  post<Abholauftrag>(`/versandrouting/abholungen/${id}/status`, s);
